import type { AvatarRig } from "./avatar-model.ts";

/** O que a animação procedural lê do corpo (predito ou interpolado). */
export interface AnimationInput {
  speed: number;
  grounded: boolean;
  crouching: boolean;
  swimming: boolean;
  sliding: boolean;
  pitch: number;
}

export interface AnimationPose {
  leg: number;
  arm: number;
  bob: number;
  crouch: number;
  lean: number;
  headPitch: number;
}

/**
 * Pose procedural (sem clipes, ADR 0007): fase de passada avança com a velocidade; pernas e braços
 * oscilam em oposição; no ar, pernas recolhidas; agachado, quadril baixa; nadando, corpo deita.
 */
export class AvatarAnimator {
  private phase = 0;

  pose(input: AnimationInput, dt: number): AnimationPose {
    const stride = Math.min(1, input.speed / 4.2);
    if (input.grounded && !input.sliding) this.phase += dt * (2.2 + input.speed * 1.5);
    const swing = Math.sin(this.phase);
    if (input.swimming) {
      return { leg: swing * 0.35, arm: Math.sin(this.phase * 1.3) * 0.9, bob: 0, crouch: 0, lean: 1.2, headPitch: -0.9 };
    }
    if (input.sliding) return { leg: -0.9, arm: 0.6, bob: 0, crouch: 0.35, lean: -0.5, headPitch: 0.3 };
    if (!input.grounded) return { leg: 0.45, arm: -0.8, bob: 0, crouch: 0.1, lean: 0.1, headPitch: input.pitch * 0.5 };
    return {
      leg: swing * 0.7 * stride,
      arm: -swing * 0.6 * stride,
      bob: Math.abs(Math.cos(this.phase)) * 0.05 * stride,
      crouch: input.crouching ? 0.3 : 0,
      lean: input.crouching ? 0.35 : stride * 0.08,
      headPitch: input.pitch * 0.5,
    };
  }
}

export function applyPose(rig: AvatarRig, pose: AnimationPose): void {
  rig.leftLeg.rotation.x = pose.leg;
  rig.rightLeg.rotation.x = -pose.leg;
  rig.leftArm.rotation.x = pose.arm;
  rig.rightArm.rotation.x = -pose.arm;
  rig.body.position.y = pose.bob - pose.crouch;
  rig.body.rotation.x = -pose.lean;
  rig.head.rotation.x = pose.headPitch;
}
